'use strict';

/** Деньги в пути */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAYMENT_STATUS_MONEY_TRANSFER = exports.PAYMENT_STATUS_MONEY_TRANSFER = 4;
/** Возврат */
var PAYMENT_STATUS_RETURN = exports.PAYMENT_STATUS_RETURN = 3;
/** Частичный возврат */
var PAYMENT_STATUS_PARTIALLY_RETURN = exports.PAYMENT_STATUS_PARTIALLY_RETURN = 13;
/** Оплачен */
var PAYMENT_STATUS_PAY = exports.PAYMENT_STATUS_PAY = 2;
/** Не оплачен */
var PAYMENT_STATUS_NOT_PAY = exports.PAYMENT_STATUS_NOT_PAY = 1;
/** Устарел */
var PAYMENT_STATUS_OUTDATED = exports.PAYMENT_STATUS_OUTDATED = 7;
// Отменен
var PAYMENT_STATUS_CANCEL = exports.PAYMENT_STATUS_CANCEL = 8;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Order/PaymentStatusConstants.js
// module id = 385
// module chunks = 0